import { createAsyncThunk } from '@reduxjs/toolkit';

import { IAnalytics } from '.';
import { APIDataProvider, ApiPaths, TApiResponse } from '../../api';

interface ICreateAnaytics {
  userId?: string;
  type: string;
  data: Record<string, unknown>;
}

const apiDataProvider = new APIDataProvider();

export const createAnalytics = createAsyncThunk(
  'analytics/create',
  async (data: ICreateAnaytics) => {
    const response = await apiDataProvider.post<TApiResponse<IAnalytics>>(
      `${ApiPaths.analytics}`,
      data
    );

    return response.data;
  }
);

export const checkAiBuddyUserDetails = createAsyncThunk(
  'analytics/checkAiBuddyUserDetails',
  async (userId: string) => {
    const response = await apiDataProvider.get<TApiResponse<any[]>>(
      `${ApiPaths.analytics}/ai-buddy-user-details?userId=${userId}`
    );

    return response.data;
  }
);

export default createAnalytics;
